var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"slot-button"},'div',_vm.$attrs,false),_vm.$listeners),[_c('AppRouterLink',{staticClass:"slot-button__link",attrs:{"text":_vm.text,"to":_vm.to}},[_c('div',{staticClass:"slot-button__icon"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }